export enum PromoFeatureName {
  // snake_case for better sync with PostHog Person Properties naming
  CombinedIncome = "combined_income"
}

export enum PromoSize {
  XS = "XS",
  SM = "SM",
  BASE = "BASE"
}

export enum PromoFeatureFlag {
  Modal = "show-promo-modal",
  Banner = "show-promo-banner"
}

export enum PromoType {
  Modal = "modal",
  Banner = "banner"
}

export type PromoContent = {
  actionButtonTitle: string;
  actionButtonLink?: string;
  imageSrc?: string;
  icons?: {
    src: string;
    alt: string;
    width?: number;
    height?: number;
    classNames?: string;
  }[];
  title?: string;
  subtitle?: string;
  description?: string;
  bulletPoints?: string[];
  onCloseClassNames?: string;
};

export type PromoContentComponentProps = {
  size: PromoSize;
  onClose?: () => void;
  onActionButtonClick?: () => void;
  featureName: PromoFeatureName;
  promoType: PromoType;
};

export type PromoShouldApplyData = {
  isBoomScreen: boolean;
  partnerCreatedAt?: string;
  featureFlagEnabled?: boolean;
  sessionPromoData: string | null;
};
